import React from 'react'
import {Hub} from 'yougile-model'
import {
  getDefaultOrganizationFields,
  getLegacyCrmFieldValueById
} from '@components/crm/default-data-fields'
import {CustomFieldInput} from '../about-client/custom-field-input'

export const OrganizationFields = ({deal}: {deal: Hub}) => {
  const fields = getDefaultOrganizationFields()

  return (
    <div className="p-6">
      {fields.map(field => {
        const value =
          deal.data.fieldValues?.[field.id] ??
          getLegacyCrmFieldValueById(deal.data, field.id) ??
          ''

        return (
          <CustomFieldInput
            key={field.id}
            label={field.label}
            value={value}
            onConfirm={nextValue => {
              deal.data.fieldValues ??= {}
              deal.data.fieldValues[field.id] = nextValue
              deal.commit()
            }}
            type={field.type}
          />
        )
      })}
    </div>
  )
}
